import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';
var lazyFullModule = new LazyModule(() => import('./lazyFullPublishPbpOption'));
let PublishPbpOption: LazyOption = createLazyOption(
    {
        key: 'publishPbpOption',
        titleStringKey: 'optionTitle_pbpPublishingOptions',
        searchTermsStringKey: 'optionTitle_pbp',
        isHidden: () => {
            return !isFeatureEnabled('cal-pbp-option');
        },
    },
    lazyFullModule,
    m => m.default
);
export default PublishPbpOption;
